import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = () => ({
    iconButton: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 40,
        height: 40,
        borderRadius: 27,
        cursor: 'pointer',
        '&.primary': {
            background: 'transparent',
            transition: '0.25s background',
            "& svg": {
                pointerEvents: 'none',
                width: 24,
                height: 24,
                color: Color.primary[500],
                transition: '0.25s color'
            },
            "&:hover": {
                background: Color.primary[100],
                transition: '0.25s background',
                "& svg": {
                    width: 24,
                    height: 24,
                    color: Color.primary[500],
                    transition: '0.25s color',
                }
            },
            "&:active": {
                "& svg": {
                    color: Color.primary[700],
                    transition: '0.25s color',
                }
            }
        },
        '&.danger': {
            background: 'transparent',
            transition: '0.25s background',
            "& svg": {
                pointerEvents: 'none',
                width: 24,
                height: 24,
                color: Color.danger[400],
                transition: '0.25s color',
            },
            "&:hover": {
                background: Color.danger[100],
                transition: '0.25s background',
                "& svg": {
                    width: 24,
                    height: 24,
                    color: Color.danger[400],
                    transition: '0.25s color',
                }
            },
            "&:active": {
                "& svg": {
                    color: Color.danger[800],
                    transition: '0.25s color',
                }
            }
        }
    }),
    primary: css({}),
    danger: css({}),
    disabled: css({
        cursor: 'auto',
        pointerEvents: 'none',
        '& svg': {
            color: `${Color.neutral[400]} !important`
        }
    })
});
